// **** detalhe empresa ****
// **** autor: Walcledson de Paula ****
// **** 08-06-24
// **** atualizado: 3/7/24w /IA 23h58 ****



import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import apiaxios from "../../../../../Services/apiaxios.js";
import { decrypt } from "../../../../../Services/cryptoUtils.js";
// import { encryptPass } from "../../../../../Services/cryptosenha.js";
import Swal from "sweetalert2";
import { Oval } from 'react-loader-spinner';
import handleApiError from "../../../../../Services/apiErrorHandler.js";
import { autoLogout } from "../../../../../Services/authutils.js";
import Menu from "../../../components/Menu/menu.jsx";
import Footer from '../../../components/Footer/footer.jsx';
import BannerCarousel from "../../../components/Banner/bannercarousel.jsx";

import './detalheempresa.css';

// const API_URL = process.env.REACT_APP_API_URL;
// const BA_USERNAME = process.env.REACT_APP_BA_USERNAME;
// const BA_PASSWORD = encryptPass(process.env.REACT_APP_BA_PASSWORD); // substituída a linha acima por esta 22/7/24w

function DetalheEmpresa() {
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");

    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            console.error('token adulterado');
            autoLogout();
        }
    }, [tokenASW, tokenlg]);

    // const [userObject, setUserObject] = useState(() => {
    //     const encryptedUser = localStorage.getItem('tokenacw');
    //     if (encryptedUser) {
    //         try {
    //             const decryptedUser = decrypt(encryptedUser);
    //             return JSON.parse(decryptedUser);
    //         } catch (error) {
    //             console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
    //             return null;
    //         }
    //     }
    //     return null;
    // });

    // // const getInitialUserData = () => {
    // const [userObject, setUserObject] = useState(() => {
    //     const encryptedUser = localStorage.getItem('tokenacw');
    //     if (encryptedUser) {
    //         try {
    //             const decryptedUser = decrypt(encryptedUser);
    //             return {
    //                 userId: decryptedUser.id_usuario || 0,
    //                 cidade: decryptedUser.cidade || ''
    //             };
    //         } catch (error) {
    //             console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
    //             return { userId: 0, cidade: '' };
    //         }
    //     }
    //     return { userId: 0, cidade: '' };
    // });

    const [userObject, setUserObject] = useState(() => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return {
                    userId: decryptedUser.id_usuario || 0,
                    cidade: decryptedUser.cidade || ''
                    // usu_ativa_conta: decryptedUser.ativa_conta || 0
                };
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                // return { userId: 0, cidade: '', usu_ativa_conta: 0 };
                return { userId: 0, cidade: '' };
            }
        }
        // return { userId: 0, cidade: '', usu_ativa_conta: 0 };
        return { userId: 0, cidade: '' };
    });

    const [userId, setUserId] = useState(() => userObject ? userObject.id_usuario : 0);
    // const [nome, setNome] = useState('');
    // const [email, setEmail] = useState('');
    
    // const [usu_ativa_conta, setUsu_ativa_conta] = useState(() => userObject ? userObject.ativa_conta : 0);
    // const [showModalAtivaConta, setShowModalAtivaConta] = useState(false);

    // useEffect(() => {
    //     if (!usu_ativa_conta || usu_ativa_conta === 0) {
    //         Swal.fire({
    //             title: 'Ativação da Conta',
    //             text: 'Para agendar um serviço no AgendeX, você precisa primeiro validar seu email. Deseja fazê-lo agora?',
    //             icon: 'question',
    //             confirmButtonColor: '#3085d6',
    //             showCancelButton: true,
    //             confirmButtonColor: '#3085d6',
    //             cancelButtonColor: '#d33',
    //             confirmButtonText: 'Sim, validar!',
    //             cancelButtonText: 'Cancelar'
    //         }).then((result) => {
    //         if (result.isConfirmed) {
    //             carregaDados(userId);
    //             // setShowModalAtivaConta(true);

    //             // const checkAgendaFechada = async () => {
    //             //     try {
    //             //         const response = await apiaxios.get('/Empresa/AgendaFechada', {
    //             //             params: { id_usuario: id }
    //             //         });
        
    //             //         if (response.status === 200) {
    //             //             const data = response.data;
    //             //             if (data.retorno !== 'OK') {
    //             //                 Swal.fire('Erro', data.retorno, 'error');
    //             //                 return false;
    //             //             }
        
    //             //             const agendaFechada = data.agenda_fechada === null ? 0 : data.agenda_fechada;

    //             //             if (agendaFechada === 1) {
    //             //                 Swal.fire('Empresa com Agenda fechada temporariamente!', '', 'info');
    //             //                 return false;
    //             //             }
    //             //             return true;
    //             //         } else {
    //             //             Swal.fire('Erro', 'Falha ao verificar o status da agenda do profissional escolhido. Tente novamente mais tarde.', 'error');
    //             //             return false;
    //             //         }
    //             //     } catch (error) {
    //             //         Swal.fire('Erro', 'Erro ao verificar o status da agenda: ' + error.message, 'error');
    //             //         return false;
    //             //     }
    //             // };
    //             // setShowModalAtivaConta(true); // removido 20/7/24w 13h18 // voltei 20/7/24w 13h28

    //         }
    //         });
    //         // atualizarEmpresas(empresa);
    //     }
    // }, []);

    // const initialUserData = getInitialUserData();
    // const [userId, setUserId] = useState(initialUserData.userId);    

    // const [userId, setUserId] = useState(() => userObject ? userObject.id_usuario : 0);

    const locationEmpresa = useLocation();
    const empresaData = locationEmpresa.state;
    // console.log('empresaDAta ', empresaData);
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [banners, setBanners] = useState([]);
    const [servicos, setServicos] = useState([]);
    const [nenhumServicoEncontrado, setNenhumServicoEncontrado] = useState(false);
    const [isFavorita, setIsFavorita] = useState(false);
    // const [mensagem, setMensagem] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (empresaData && empresaData.id_empresa) {
            const url = `/empresa/CarregaFotoPerfil?id_empresa=${empresaData.id_empresa}`;
            setLoading(true);
            apiaxios.get(url)
                .then(async (response) => {
                    setLoading(false);
                    if (response.data.retorno === "OK" && response.data.foto) {
                        setFotoPerfil(`data:image/jpeg;base64,${response.data.foto}`);
                    }
                    const empresaServicos = await fetchServicos(empresaData.id_empresa);
                    setServicos(empresaServicos);
                }).catch(error => {
                    setLoading(false);
                    handleApiError(error);
                });
        }
    }, []);

    useEffect(() => {
        const verificarFavorita = async () => {
            try {
                const response = await apiaxios.get(`/empresa/VerificaFavorita?id_usuario=${userId}&id_empresa=${empresaData.id_empresa}`);
                if (response.data.retorno === "OK") {
                    setIsFavorita(response.data.like === "1");
                }
            } catch (error) {
                handleApiError(error);
            }
        };

        if (userId && empresaData && empresaData.id_empresa) {
            verificarFavorita();
        }
    }, [userId, empresaData]);

    if (!empresaData) {
        return <div>Nenhuma informação da empresa encontrada.</div>;
    }

    const fetchServicos = async (id_empresa) => {
        try {
            setLoading(true);
            const servicosResponse = await apiaxios.get(`/servico/listar?id_empresa=${id_empresa}`);
            console.log('id_empresa fetch', id_empresa);
            setLoading(false);
            console.log('servicosResponse.data', servicosResponse.data);
            if (servicosResponse.status === 200 && servicosResponse.data.length > 0) {
                return servicosResponse.data;
            } else {
                Swal.fire('Nenhum serviço encontrado para esta empresa.');
                return [];
            }
        } catch (error) {
            setLoading(false);
            handleApiError(error);
            return [];
        }
    };

    const carregaBanner = () => {
        const url = `/Banner/crud?id_empresa=${empresaData.id_empresa}&pagina=1&tamanho_pagina=15`;
        setLoading(true);
        apiaxios.get(url)
            .then(response => {
                setLoading(false);
                if (response.status === 200 && response.data.length > 0) {
                    setBanners(response.data);
                    setModalOpen(true);
                } else {
                    Swal.fire('Nenhum banner encontrado para este prestador.');
                }
            }).catch(error => {
                setLoading(false);
                handleApiError(error);
            });
    };

    const closeModal = () => setModalOpen(false);

    const CarregaServico = (id_servico, id_empresa, nome_servico, vr_servico, tipo_agenda) => {
        const servicoData = {
            id_servico,
            id_empresa,
            nome_servico,
            vr_servico,
            tipo_agenda
        };
        navigate('/app/cliente/home/explorar/empresa/agendar', { state: servicoData });
    };

    const formatCurrency = (value) => {
        if (value === undefined || value === null) {
            return 'R$ 0,00';
        }
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const alterarFavorita = async () => {
        try {
            const url = `/Empresa/AlterarFavorita`;

            if (isFavorita) {
                const deleteResponse = await apiaxios.delete(url, {
                    params: {
                        id_usuario: userId,
                        id_empresa: empresaData.id_empresa
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (deleteResponse.status === 200 && deleteResponse.data.retorno === "OK") {
                    const novaQuantidadeFavoritas = deleteResponse.data.quantidade_favoritas;
                    setIsFavorita(false);
                    const updatedUserObject = { ...userObject, quantidade_favoritas: novaQuantidadeFavoritas };
                    // const updatedUserObject = { ...initialUserData, quantidade_favoritas: novaQuantidadeFavoritas };
                    setUserObject(updatedUserObject);
                    localStorage.setItem("tokenacw", JSON.stringify(updatedUserObject));
                    Swal.fire('Empresa desfavoritada com sucesso!');
                } else {
                    throw new Error('Erro ao remover favorita: ' + deleteResponse.data.retorno);
                }
            } else {
                const quantidadeFavoritas = userObject.quantidade_favoritas || 0;
                // const quantidadeFavoritas = initialUserData.quantidade_favoritas || 0;
                if (quantidadeFavoritas >= 3) {
                    Swal.fire('Você atingiu o seu limite de empresas favoritas!');
                    return;
                }

                const params = {
                    'Content-Type': 'application/json',
                    'id_usuario': userId
                };
                const data = {
                    id_empresa: empresaData.id_empresa
                };

                const postResponse = await apiaxios.post(url, data, { params });
                if (postResponse.status === 201 && postResponse.data.retorno === "OK") {
                    const novaQuantidadeFavoritas = postResponse.data.quantidade_favoritas;
                    setIsFavorita(true);
                    const updatedUserObject = { ...userObject, quantidade_favoritas: novaQuantidadeFavoritas };
                    setUserObject(updatedUserObject);
                    localStorage.setItem("tokenacw", JSON.stringify(updatedUserObject));
                    Swal.fire('Empresa favoritada com sucesso!');
                } else {
                    throw new Error('Erro ao adicionar favorita: ' + postResponse.data.retorno);
                }
            }
        } catch (error) {
            handleApiError(error);
        }
    };

    // const carregaDados = async (idUsuario) => {
    //     setLoading(true);
    //     try {
    //         const response = await apiaxios.post('/usuario/perfilWeb', {
    //             id_usuario: idUsuario, // Usar idUsuario aqui
    //             tipo_app: 0
    //         });
    //         if (response.status === 200) {
    //             const data = response.data;
    //             if (data.retorno === 'OK') {
    //                 setNome(data.nome);
    //                 setEmail(data.email);
    //                 setUsu_ativa_conta(data.ativa_conta);
    //                 generateValidationCode(email);
    //             } else {
    //                 Swal.fire('Erro', data.retorno, 'error');
    //             }
    //         } else {
    //             Swal.fire('Erro', 'Falha ao carregar seus dados. Tente novamente mais tarde.', 'error');
    //         }
    //     } catch (error) {
    //         handleApiError(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // function generateCV() {
    //     return Math.floor(100000 + Math.random() * 900000).toString();
    // }

    // async function generateValidationCode(email) {

    //     if (!email) {
    //         setMensagem('Email não pode ficar em branco.');
    //         // setSucesso(false);

    //         setTimeout(() => {
    //             setMensagem('');
    //         }, 7000);
    //         return;
    //     }

    //     const authString = btoa(`${BA_USERNAME}:${BA_PASSWORD}`);
    //     const url = new URL(`${API_URL}/usuario/ContaExistente`);
    //     url.search = new URLSearchParams({
    //         email: email,
    //         tipoApp: 0 // Ensure tipoApp is sent as an Integer
    //     }).toString();

    //     setLoading(true);

    //     try {
    //         const response = await fetch(url.toString(), {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Basic ${authString}`
    //             }
    //         });
    //         if (!response.ok) {
    //             const data = await response.json();
    //             throw new Error(data.retorno);
    //         }

    //         setLoading(false);

    //         // setSucesso(true);

    //         const data = await response.json();
    //         const userName = data.nome; // Assume the response contains the user's name

    //         const validationCode = generateCV();
    //         const validationUrl = new URL(`${API_URL}/usuario/validaEmail`);
    //         validationUrl.search = new URLSearchParams({
    //             nome,
    //             email,
    //             codigo: validationCode
    //         }).toString();

    //         const validationResponse = await fetch(validationUrl.toString(), {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Basic ${authString}`
    //             }
    //         });

    //         if (!validationResponse.ok) {
    //             const validationData = await validationResponse.json();
    //             throw new Error(validationData.retorno);
    //         }
    //         // Save the code in a state or send it to the email
    //         // console.log("Validation Code: ", validationCode);

    //         // After successful email check, navigate to the next screen
    //         navigate('/app/perfil/cv', { state: { email: email, validationCode: validationCode } });

    //         // navigate('/app/resetsenha/cv'); // Navigate to the code verification page            
    //         // navigate('/app/resetsenha/cv');

    //     } catch (error) {
    //         // Trate o erro
    //         setLoading(false);

    //         console.error('Fetch error:', error);
    //         if (error.message.includes('CORS policy')) {
    //             setMensagem('Erro de CORS. Verifique as configurações do servidor.');            
    //         } else if (error.message === 'Failed to fetch') {
    //             setMensagem('Erro de conexão. Verifique sua conexão com a internet e tente novamente.');            
    //         } else {
    //             setMensagem(error.message);
    //         }

    //         setTimeout(() => {
    //             setMensagem('');
    //         }, 7000);
    //     }
    // }


    return <>
    <div className="c_detalheempresa">
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    {/* <Navbar /> */}
                    <Menu page="detalheempresa"/>
                </div>
                <div className="col py-3 me-3">
                    <div>
                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                            )}
                            {fotoPerfil ? (
                                // <img className="img-prestador" src={fotoPerfil} alt="imagem de capa do Prestador"/>
                                <div className='text-center'>
                                    <img src={fotoPerfil} alt="Imagem de capa do Prestador" className='img-prestador' onClick={carregaBanner} />
                                </div>
                            ) : (
                                <p>Carregando imagem...</p>                                        
                        )}
                    </div>
                    <div className="col-lg-12 col-md-4 col-sm-12">
                        <div className='box-detalhe-empresa'>
                            <div className='row '>
                                <p className="col py-3">
                                    {empresaData.endereco_empresa}
                                </p>
                                <div className="col d-flex justify-content-end">
                                    <button
                                        className="btn btn-link"
                                        onClick={alterarFavorita}
                                    >
                                        <i className={`fs-1 bi ${isFavorita ? 'bi-heart-fill text-danger' : 'bi-heart'}`}></i>
                                    </button>
                                </div>                                    
                                <h5>
                                    {empresaData.fone_empresa}
                                </h5>
                                <hr />
                            </div>
                            <h1>
                                {empresaData.nome_empresa}
                            </h1>
                        </div>
                    </div> 

                    <h4>Serviços</h4>
                    <hr />
                    <div className={`row ${loading ? 'd-none' : ''}`}></div>
                    {loading && (
                        <div className="loading-spinner-container">
                            <Oval color="#00BFFF" height={80} width={80} />
                        </div>
                    )}
                    {nenhumServicoEncontrado ? (
                        <div className="alert alert-danger mt-2" role="alert">
                            Nenhum "Serviço" disponível neste momento pra esta empresa...
                        </div>
                    ) : (
                        <div className="box-explorarempresas">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Valor</th>
                                        <th>Vr Deconto</th>
                                        <th>Vr Total</th>
                                        <th>% Desconto</th>
                                        <th className="text-right">Agendar</th>
                                    </tr>
                                </thead>  
                                <tbody>
                                    {servicos.map((servico) => (
                                        <tr key={servico.ID_SERVICO}>
                                            <td data-label="Descrição:">{servico.DESCRICAO}</td>
                                            {/* <td data-label="Valor:"> */}
                                            <td data-label="Valor:" className={servico.VALOR === 0 ? 'highlight-red' : ''}>
                                                {servico.VALOR === 0 ? 'VALOR A COMBINAR' : formatCurrency(servico.VALOR)}
                                            </td>
                                            <td data-label="Vr.Desconto:">
                                                {servico.VR_DESCONTO === 0 ? (
                                                    'N/A'
                                                ) : (
                                                    formatCurrency(servico.VR_DESCONTO)
                                                )}
                                            </td>
                                            <td data-label="Valor:">
                                                {servico.VR_TOTAL === 0 ? (
                                                    'N/A'
                                                ) : (
                                                    formatCurrency(servico.VR_TOTAL)
                                                )}
                                            </td>
                                            <td data-label="% Desc.:" className={servico.VR_DESCONTO > 0 ? 'text-right highlight-red' : 'text-right'}>
                                                {servico.VR_TOTAL === 0 ? (
                                                    'N/A'
                                                ) : (
                                                    `${(servico.VR_DESCONTO / servico.VALOR * 100).toFixed(2)} %`
                                                )}
                                            </td>
                                            <td data-label="Agendar">
                                                <button
                                                    className="btn btn-info ml-10"
                                                    onClick={() => CarregaServico(
                                                        servico.ID_SERVICO,
                                                        empresaData.id_empresa,
                                                        servico.DESCRICAO,
                                                        servico.VR_TOTAL,
                                                        empresaData.tipo_agenda
                                                        // 0
                                                    )}
                                                >
                                                    <i className="bi bi-calendar-plus-fill"></i> Agendar
                                                </button>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>

    <Footer />

    <div className={`modal fade ${modalOpen ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: modalOpen ? 'block' : 'none' }}> 
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header d-flex justify-content-center">
                    <h5 className="modal-title">Banner Promocional</h5>
                    {/* <div className="text-right"> */}
                        <button type="button" className="close" onClick={closeModal} aria-label="Close" style={{ position: 'absolute', right: '10px' }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    {/* </div> */}
                </div>
                <div className="modal-body">
                    {loading && <p>Carregando...</p>}
                    {!loading && banners.length > 0 && <BannerCarousel banners={banners} />}
                </div>
            </div>
        </div>
    </div>

</>
};

export default DetalheEmpresa;